export default "__VITE_PUBLIC_ASSET__85df07ee__"